module.exports = __webpack_public_path__ + "img/d_sv3.e774a38.png";